import { Button, Form, Row, Space } from "@masterteam/mt-design-react";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { object, string } from "yup";
import { addToast } from "../../../helpers";
import api from "../../../providers/api";
import AdminFormModal from "../../AdminFormModal";

import "./style.scss";

const { Field } = Form;

const validationSchema = object().shape({
  EnglishName: string().required(" "),
  ArabicName: string().required(" "),
  EnglishDescription: string().required(" "),
  ArabicDescription: string().required(" "),
  Code: string().required(" "),
  ManagerModel: object().required(" ").nullable(),
  Strategy: object().required(" ").nullable(),
  Pillars: object().required(" ").nullable(),
  Objective: object().required(" ").nullable(),
});

const StrategyForm = ({ data, closeModal, setIsPostedData }) => {
  const isEdit = !!data?.ID
  const [users,setUsers] = useState([])
  const [objectives,setObjectives] = useState([])
  const intl = useIntl();
  const isAr = intl.locale === "ar";
  setIsPostedData(false);
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    EnglishName: "",
    ArabicName: "",
    EnglishDescription: "",
    ArabicDescription: "",
    Code: "",
    ManagerModel: null,
    Strategy: null,
    Pillars: null,
    Objective: null,
  });

  const getInitiativeData = () => {
    setLoading(true);
    api.initiatives
      .getById(data?.ID)
      .then((res) => {
        const {Objective} = res?.Data
        setInitialValues({
          ...res.Data,
          Strategy:Objective?.Pillar?.Strategy,
          Pillars: Objective?.Pillar
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const getFormData = async() => {
    try {
      const [
        usersRes,
        objectiveRes
      ] = await Promise.all([
        api.user.getAll(),
        api.strategy.getAllWithObjectives({strategyType: 2}),
      ]);
      setUsers(usersRes.StatusCode === "Success" ? usersRes.Data : [])
      setObjectives(usersRes.StatusCode === "Success" ? objectiveRes.Data : [])
    } catch (error) {
      addToast.error(error?.message, {
        toastId: "get-users-error"
      });
    }
  }

  useEffect(() => {
    if (data) {
      getInitiativeData();
    }
    getFormData()
  }, []);

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const body = {
        ...values,
        ManagerModel:{
          UserName: values?.ManagerModel?.UserName
        },
        Objective:{
          ID: values?.Objective?.ID
        },
      };
      let res;
      if(isEdit){
        body.ID = data?.ID
        res = await api.initiatives.update(body);
      }else{
        res = await api.initiatives.create(body);
      }
      const { StatusCode } = res;
       if (StatusCode === "Success") {
        addToast.success(isEdit ? "toast.successUpdate" : "toast.successSave");
        closeModal();
        setIsPostedData(true);
      }
    } catch (error) {
      addToast.error(error?.message, {
        toastId: "get-users-error"
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AdminFormModal
      title={intl.formatMessage({
        id: data ? "common.update-initiative" : "common.add-initiative"
      })}
      isLoading={loading}
      onClose={closeModal}
    >
      <Form
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, isValid, values, setFieldValue }) => (
          <>
            <Space
              direction="vertical"
              size="medium"
              className="strategy-form-body"
            >
              <Space direction="vertical" className="form-container">
                <Row size="small">
                  <Field
                    name="ArabicName"
                    label={intl.formatMessage({ id: "initiative.title-arabic-name" })}
                    inputProps={{
                      maxLength: 256,
                      placeholder: intl.formatMessage({
                        id: "common.arabic-name"
                      })
                    }}
                    required
                  />

                  <Field
                    name="EnglishName"
                    label={intl.formatMessage({ id: "initiative.title-english-name" })}
                    inputProps={{
                      maxLength: 256,
                      placeholder: intl.formatMessage({
                        id: "common.english-name"
                      })
                    }}
                    required
                  />
                </Row>

                <Row size="small">
                  <Field
                    type="textarea"
                    name="ArabicDescription"
                    label={intl.formatMessage({
                      id: "initiative.arabic-description"
                    })}
                    inputProps={{
                      maxLength: 150,
                      placeholder: intl.formatMessage({
                        id: "initiative.arabic-description"
                      })
                    }}
                    required
                  />

                  <Field
                    type="textarea"
                    name="EnglishDescription"
                    label={intl.formatMessage({
                      id: "initiative.english-description"
                    })}
                    inputProps={{
                      maxLength: 150,
                      placeholder: intl.formatMessage({
                        id: "initiative.english-description"
                      })
                    }}
                    required
                  />
                </Row>
                <Row size="small">
                <Field
                    type="text"
                    span={12}
                      name="Code"
                      label={intl.formatMessage({
                        id: "initiative.code"
                      })}
                      required
                  />
                  <Field
                      name="ManagerModel"
                      type="select"
                      label={intl.formatMessage({
                        id: "project.initiative-manager"
                      })}
                      required
                      inputProps={{
                        options: users,
                        getOptionLabel: (el) => el?.DisplayName,
                        getOptionValue: (el) => el?.UserName,
                        placeholder: intl.formatMessage({
                          id: "project.initiative-manager"
                        })
                      }}
                  />
                </Row>
                  <Row size="small">
                  <Field
                      name="Strategy"
                      span={6}
                      type="select"
                      label={intl.formatMessage({
                        id: "common.strategy"
                      })}
                      required
                      inputProps={{
                        options: objectives,
                        getOptionLabel: (el) => isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el?.ID,
                        placeholder: intl.formatMessage({
                          id: "common.strategy"
                        }),
                        onChange: (e) => {
                          if(e && (e.ID == values?.Strategy?.ID)) return;
                          setFieldValue("Strategy", e);
                          setFieldValue("Pillars", null);
                          setFieldValue("Objective", null);
                        },
                      }}
                     
                  />
                   <Field
                      name="Pillars"
                      type="select"
                      label={intl.formatMessage({
                        id: "common.pillar"
                      })}
                      required
                      inputProps={{
                        options: objectives?.find(item => item?.ID === values?.Strategy?.ID)?.Pillars || [],
                        getOptionLabel: (el) => isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el?.ID,
                        placeholder: intl.formatMessage({
                          id: "common.pillar"
                        }),
                        onChange: (e) => {
                          if(e && (e.ID == values?.Pillars?.ID)) return;
                          setFieldValue("Pillars", e);
                          setFieldValue("Objective", null);
                        },
                      }}
                  />
                  </Row>
                  <Row size="small">
                  <Field
                      name="Objective"
                      span={6}
                      type="select"
                      label={intl.formatMessage({
                        id: "common.strategic-objective"
                      })}
                      required
                      inputProps={{
                        options: objectives?.find(item => item?.ID === values?.Strategy?.ID)?.Pillars?.find(item => item?.ID === values?.Pillars?.ID)?.Objectives || [],
                        getOptionLabel: (el) => isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el?.ID,
                        placeholder: intl.formatMessage({
                          id: "common.strategic-objective"
                        }),
                        onChange: (e) => {
                          setFieldValue("Objective", e);
                        },
                        menuPlacement: "top",
                      }}
                  />
                  </Row>

              </Space>

              <Row justify="end" className="form-footer">
                <Button
                  loading={isSubmitting}
                  disabled={!isValid}
                  variant="primary"
                  type="submit"
                  fixed
                >
                  {intl.formatMessage({
                    id: data ? "common.update" : "common.add"
                  })}
                </Button>
              </Row>
            </Space>
          </>
        )}
      </Form>
    </AdminFormModal>
  );
};

export default StrategyForm;
